import { Zone, Component } from './types'
export const sampleZones: Zone[] = [
  { id: 1, name: 'Stue', area: 38, type: 'living' },
  { id: 2, name: 'Køkken', area: 16, type: 'kitchen' },
  { id: 3, name: 'Bad', area: 6, type: 'bathroom' },
  { id: 4, name: 'Soveværelse', area: 14, type: 'bedroom' },
  { id: 5, name: 'Børneværelse 1', area: 12, type: 'bedroom' },
  { id: 6, name: 'Børneværelse 2', area: 10, type: 'bedroom' },
  { id: 7, name: 'Entré', area: 8, type: 'hallway' },
  { id: 8, name: 'Bryggers', area: 6, type: 'utility' },
]
export const sampleComponents: Component[] = [
  // Manifolds
  {
    id: 1,
    brand: 'Roth',
    model: 'Gulvvarmefordeler 6 afgr.',
    category: 'manifold',
    price: 4250,
    keyData: ['6 kredse', '1" tilslutning', 'Inkl. flowmåler', 'Rustfri'],
    eta: 'På lager',
    inStock: true,
    badges: ['Anbefalet'],
  },
  {
    id: 2,
    brand: 'Roth',
    model: 'Gulvvarmefordeler 8 afgr.',
    category: 'manifold',
    price: 5100,
    keyData: ['8 kredse', '1" tilslutning', 'Inkl. flowmåler', 'Rustfri'],
    eta: 'På lager',
    inStock: true,
    badges: ['Grøn'],
  },
  {
    id: 3,
    brand: 'CompA',
    model: 'Fordeler Basic 6 afgr.',
    category: 'manifold',
    price: 3800,
    keyData: ['6 kredse', '1" tilslutning', 'Manuel udluftning', 'Messing'],
    eta: '2-3 uger',
    inStock: false,
  },
  // Pipes
  {
    id: 4,
    brand: 'Roth',
    model: 'X-PERT S5® 16 mm',
    category: 'pipe',
    price: 18.5,
    keyData: ['16 mm', '2.0 mm godstykkelse', 'Ilt-diffusionstæt', 'PE-RT'],
    eta: 'På lager',
    inStock: true,
    badges: ['Grøn', 'Anbefalet'],
  },
  {
    id: 5,
    brand: 'Roth',
    model: 'X-PERT S5® 20 mm',
    category: 'pipe',
    price: 23.5,
    keyData: ['20 mm', '2.0 mm godstykkelse', 'Ilt-diffusionstæt', 'PE-RT'],
    eta: 'På lager',
    inStock: true,
    badges: ['Grøn'],
  },
  {
    id: 6,
    brand: 'CompB',
    model: 'FlexPipe 16 mm',
    category: 'pipe',
    price: 15.5,
    keyData: ['16 mm', '1.8 mm godstykkelse', 'Ilt-diffusionstæt', 'PE-X'],
    eta: 'På lager',
    inStock: true,
  },
  // Thermostats
  {
    id: 7,
    brand: 'Roth',
    model: 'Touchline® SL WiFi',
    category: 'thermostat',
    price: 1450,
    keyData: ['WiFi', 'App-styring', 'Ugeprogram', 'Adaptiv start'],
    eta: 'På lager',
    inStock: true,
    badges: ['Anbefalet'],
  },
  {
    id: 8,
    brand: 'Roth',
    model: 'Standard Termostat',
    category: 'thermostat',
    price: 550,
    keyData: ['Kablet', 'Simpel betjening', 'Robust', 'M28 tilslutning'],
    eta: 'På lager',
    inStock: true,
  },
  {
    id: 9,
    brand: 'CompA',
    model: 'WiFi-termostat M30',
    category: 'thermostat',
    price: 1250,
    keyData: ['WiFi', 'App-styring', 'M30 tilslutning', 'Batteri'],
    eta: '2-3 uger',
    inStock: false,
  },
  // Pumps
  {
    id: 10,
    brand: 'Roth',
    model: 'Shuntpumpe A-label',
    category: 'pump',
    price: 3950,
    keyData: ['A-mærket', 'Lavt energiforbrug', 'Automatisk', 'Inkl. kappe'],
    eta: 'På lager',
    inStock: true,
    badges: ['Grøn', 'Anbefalet'],
  },
  {
    id: 11,
    brand: 'CompB',
    model: 'Cirkulationspumpe',
    category: 'pump',
    price: 3750,
    keyData: ['B-mærket', '3 hastigheder', 'Manuel indstilling', 'Kompakt'],
    eta: 'På lager',
    inStock: true,
  },
  // Ventilation
  {
    id: 12,
    brand: 'Roth',
    model: 'Ventilationskit',
    category: 'ventilation',
    price: 12500,
    keyData: ['Varmegenvinding', 'Lavt lydniveau', 'Filter G4', 'Kompakt'],
    eta: '1-2 uger',
    inStock: false,
    badges: ['Grøn'],
  },
  {
    id: 13,
    brand: 'CompA',
    model: 'Ventilationsanlæg Basic',
    category: 'ventilation',
    price: 9800,
    keyData: ['Simpel betjening', 'Uden genvinding', 'Filter G3', 'Støjsvag'],
    eta: '2-3 uger',
    inStock: false,
  },
  // Accessories
  {
    id: 14,
    brand: 'Roth',
    model: 'Adaptere M30→M28',
    category: 'accessory',
    price: 85,
    keyData: ['Konvertering', 'M30 til M28', 'Metal', '2-pak'],
    eta: 'På lager',
    inStock: true,
  },
  {
    id: 15,
    brand: 'Roth',
    model: 'Isoleringsplader 20mm',
    category: 'accessory',
    price: 125,
    keyData: ['20 mm', 'EPS', 'Varmeledningsevne 0.036', '1 m²/plade'],
    eta: 'På lager',
    inStock: true,
    badges: ['Grøn'],
  },
]
